/* istanbul ignore file */
import { array as codecArray, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const NewAutoTestAllowedInitialBuildIdsSettingParser = 
/* #__PURE__ */ parsers.object([
    [
        'name',
        /* #__PURE__ */ parsers.exactly('NEW_AUTO_TEST_ALLOWED_INITIAL_BUILD_IDS'),
    ],
    [
        'value',
        /* #__PURE__ */ parsers.maybeNull(/* #__PURE__ */ codecArray(codecString)),
    ],
]);
export class NewAutoTestAllowedInitialBuildIdsSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NewAutoTestAllowedInitialBuildIdsSettingParser.decode(input).map(res => new NewAutoTestAllowedInitialBuildIdsSetting(res));
    }
    static unsafeDecode(input) {
        return NewAutoTestAllowedInitialBuildIdsSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NewAutoTestAllowedInitialBuildIdsSettingParser.encode(data);
    }
    static schema() {
        return NewAutoTestAllowedInitialBuildIdsSettingParser.schema();
    }
}
